module.exports = __webpack_public_path__ + "4de42a25b3df397eb08c886d11fba51d.jpg";